import * as yup from 'yup';

export const commonEquipmentCodeIndMappingValidation: { [x: string]: any; } = {
    equipmentCodeList: yup.array().of(yup.string()).required("Missing.").min(1, "Missing."),
    equipmentCodeInd: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createEquipmentCodeIndMappingValidation: { [x: string]: any; } = {
    ...commonEquipmentCodeIndMappingValidation,
};

export const createEquipmentCodeIndMappingValidationSchema = yup.object().shape(createEquipmentCodeIndMappingValidation);

